<app-titled-page heading="Máquinas">
  <router-outlet></router-outlet>
</app-titled-page>
